import React, { useState } from 'react';
import { Button } from 'antd';
import { FileExclamationOutlined } from '@ant-design/icons';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { CargoCmrReceivedUpdateModal } from './components/cargo-cmr-received-update-modal';
import type { ICargoCmrReceivedUpdateComponentProps } from './types';

export const CargoCmrReceivedUpdateComponent: React.FC<ICargoCmrReceivedUpdateComponentProps> = (props) => {
  const { cargoId, cmrReceived } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <Button icon={<FileExclamationOutlined />} onClick={handleOpen}>
        CMR
      </Button>
      <CargoCmrReceivedUpdateModal
        cargoId={cargoId}
        cmrReceived={cmrReceived}
        isOpen={isModalOpen}
        onClose={handleClose}
      />
    </>
  );
};

export const CargoCmrReceivedUpdate = withRoleGuard<ICargoCmrReceivedUpdateComponentProps>(
  CargoCmrReceivedUpdateComponent,
  [UserRole.admin, UserRole.assistant, UserRole.storekeeper],
);
